/** Pure navigation helpers for the spatial market rooms. */

export type SpawnEntry = "fromLeft" | "fromRight" | "center";
export type BoardTab = "trades" | "gallery";

/** Inset from the wall the avatar spawns at after a room transition — clear
 *  of the door trigger zones so arriving never instantly re-fires a door. */
const SPAWN_INSET = 48;
/** Door trigger tolerance from each wall (matches ShopScene's exit zone). */
const DOOR_TOLERANCE = 6;

export function spawnForEntry(entry: SpawnEntry, worldWidth: number): { x: number; flipX: boolean } {
  switch (entry) {
    case "fromLeft":
      return { x: SPAWN_INSET, flipX: false };
    case "fromRight":
      return { x: worldWidth - SPAWN_INSET, flipX: true };
    case "center":
    default:
      return { x: worldWidth / 2, flipX: false };
  }
}

export function atLeftDoor(heroX: number, tolerance = DOOR_TOLERANCE): boolean {
  return heroX <= 12 + tolerance;
}

export function atRightDoor(heroX: number, worldWidth: number, tolerance = DOOR_TOLERANCE): boolean {
  return heroX >= worldWidth - 12 - tolerance;
}

/** Given Q/L1 (left) and E/R1 (right) edge presses + the active tab, the tab
 *  to switch to, or null if no switch (no press, or already on that tab). */
export function tabIntent(
  tabLeftPressed: boolean,
  tabRightPressed: boolean,
  active: BoardTab,
): BoardTab | null {
  if (tabRightPressed && active !== "gallery") return "gallery";
  if (tabLeftPressed && active !== "trades") return "trades";
  return null;
}
